import { Controller } from "@hotwired/stimulus";

// Submits a POST form programmatically when an element is clicked, bypassing
// the auth/elevate intermediate page. Falls back to href if JS is unavailable.
export default class extends Controller {
  static values = { url: String, origin: String };

  submit(event) {
    event.preventDefault();
    const form = document.createElement("form");
    form.method = "POST";
    form.action = this.urlValue;

    const token = document.querySelector('meta[name="csrf-token"]')?.content;
    if (token) this.#hidden(form, "authenticity_token", token);
    if (this.originValue) this.#hidden(form, "origin", this.originValue);

    document.body.appendChild(form);
    form.submit();
  }

  #hidden(form, name, value) {
    const input = document.createElement("input");
    input.type = "hidden";
    input.name = name;
    input.value = value;
    form.appendChild(input);
  }
}
